import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

interface ControllerGuardProps {
  children: React.ReactNode;
}

export default function ControllerGuard({ children }: ControllerGuardProps) {
  const { isAuthenticated, isController, token } = useAuthStore();

  if (!isAuthenticated && !token) {
    return <Navigate to="/login" replace />;
  }

  if (!isController) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
